import { useGlobalNavigation } from 'src/contexts/global-navigation-context'
import { useMenu } from 'src/contexts/menu-context'
import { LEVELS } from '../constants'
import { AlphabeticalMenu } from './MenuComponents/AlphabeticalMenu/AlphabeticalMenu'
import { ListMenu } from './MenuComponents/ListMenu/ListMenu'

export const SecondLevel = () => {
  const { updatedMenu } = useGlobalNavigation()
  const { state } = useMenu()

  return (
    <div
      className={`w-[360px] h-screen navigation-panel-step ${
        typeof state.firstLevelItem?.index === 'number' &&
        updatedMenu[state.firstLevelItem.index]?.isDesktop &&
        updatedMenu[state.firstLevelItem.index]?.nextLevel?.items !== null
          ? 'active'
          : ''
      }`}
    >
      {typeof state.firstLevelItem?.index === 'number' &&
        updatedMenu[state.firstLevelItem.index]?.nextLevel?.items !== null &&
        (updatedMenu[state.firstLevelItem.index]?.nextLevel
          ?.alphabeticalMenu ? (
          <AlphabeticalMenu
            menu={updatedMenu[state.firstLevelItem?.index]?.nextLevel}
          />
        ) : (
          <ListMenu
            menu={
              updatedMenu.find((el) => el.index === state.firstLevelItem?.index)
                ?.nextLevel!
            }
            type={LEVELS.second_level.toString()}
            level={LEVELS.second_level}
          />
        ))}
    </div>
  )
}
